import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { printingServices } from '@/mocks/services'

export default function PrintingSection() {
  const { t } = useTranslation()

  return (
    <section id="printing" className="relative w-full bg-foreground-950 py-20 md:py-28 overflow-hidden">
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-primary-900/30 blur-3xl" />
      <div className="absolute -bottom-32 -left-24 w-96 h-96 rounded-full bg-accent-900/20 blur-3xl" />

      <div className="relative w-full px-4 md:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12 md:mb-16">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-primary-400" />
              <span className="section-label text-primary-400 text-[11px] md:text-xs font-medium">
                {t('printing.label')}
              </span>
            </div>
            <h2 className="font-heading text-3xl md:text-5xl font-semibold text-background-50 leading-tight">
              {t('printing.title')}
            </h2>
          </div>
          <p className="text-base text-background-300 leading-relaxed max-w-md">{t('printing.intro')}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {printingServices.map((item) => (
            <article
              key={item.id}
              className="group rounded-lg border border-background-800/70 bg-background-50/[0.03] p-6 md:p-7 transition-colors hover:border-primary-500/70 hover:bg-background-50/[0.06]"
            >
              <div className="flex items-start justify-between gap-4 mb-5">
                <span className="w-12 h-12 rounded-full flex items-center justify-center bg-background-50/5 text-primary-400 border border-background-800/70">
                  <i className={`${item.icon} text-2xl`} />
                </span>
                <span className="text-[11px] tracking-wider uppercase px-3 py-1 rounded-full bg-primary-500/15 text-primary-300 whitespace-nowrap">
                  {t(`printing.items.${item.id}.tag`)}
                </span>
              </div>
              <h3 className="font-heading text-xl md:text-2xl font-semibold text-background-50 mb-2">
                {t(`printing.items.${item.id}.title`)}
              </h3>
              <p className="text-sm text-background-400 leading-relaxed">{t(`printing.items.${item.id}.desc`)}</p>
            </article>
          ))}
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 h-12 px-8 rounded-md bg-primary-500 text-background-50 text-sm font-medium tracking-wide whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
          >
            <i className="ri-file-text-line text-lg" />
            {t('common.getPrintQuote')}
          </Link>
          <Link
            to="/gallery"
            className="inline-flex items-center gap-2 h-12 px-8 rounded-md border border-background-100/40 text-background-50 text-sm font-medium tracking-wide whitespace-nowrap cursor-pointer hover:bg-background-50/10 transition-colors"
          >
            <i className="ri-image-2-line text-lg" />
            {t('common.seeOurWork')}
          </Link>
        </div>
      </div>
    </section>
  )
}